<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    {{ selected }}
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="3">
              <display-field
                label="Site id"
                :site="site"
                :editable="true"
                edit-field="site.T2Siteid"
                :edit-value="site.site_id"
                @updated="(nv)=>site.site_id=nv"
              >{{ site.site_id|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Candidate"
            >{{ site.candidate|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Site name"
              :site="site"
              :editable="true"
              edit-field="site.sitename"
              :edit-value="site.site_name"
              :aid="site.site_name"
              @updated="(nv)=>site.site_name=nv"
            >
              {{ site.site_name|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Active candidate"
              :editable="true"
              edit-field="site.ActiveCandidate"
              :edit-value="parseInt(site.active_candidate)"
              edit-type="boolean"
              @updated="(nv)=>site.active_candidate=nv"
            >{{ site.active_candidate|formatBool|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="County">{{ site.city|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Municiplaity"
              :editable="true"
              edit-field="site.municipality"
              :edit-value="site.municipality"
              @updated="(nv)=>site.municipality=nv"
            >{{ site.municipality|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Easting GK5">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Northing GK5">Data not available</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Easting HTRS96">
              {{ site.HTRS96Easting|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Northing HTRS96">
              {{ site.HTRS96Northing|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Latitude WGS84"
              :editable="true"
              edit-field="site.latitude"
              :edit-value="site.latitude|formatCoordinates"
              @updated="(nv)=>site.latitude=nv"
              :update-params="{'longitude': site.longitude}"
            >{{ site.latitude|formatCoordinates|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Longitude WGS84"
              :editable="true"
              edit-field="site.longitude"
              :edit-value="site.longitude|formatCoordinates"
              @updated="(nv)=>site.longitude=nv"
              :update-params="{'latitude': site.latitude}"
            >{{ site.longitude|formatCoordinates|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(location, 'construction_height')"
              @input="setValue(location, 'construction_height', $event)"
              label="Construction Height"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Coordinates - Elevation">{{ location.elevation|formatHeight|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Address"
              :editable="true"
              edit-field="site.Adress"
              :edit-value="site.address"
              @updated="(nv)=>site.address=nv"
            >{{ site.address|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Town">{{ site.city|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(location, 'external_host_id')"
              @input="setValue(location, 'external_host_id', $event)"
              label="External Host ID"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(location, 'external_host_sitename')"
              @input="setValue(location, 'external_host_sitename', $event)"
              label="External Host Sitename"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(location, 'ground_height')"
              @input="setValue(location, 'ground_height', $event)"
              label="Ground Height"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(location, 'host')"
              @input="setValue(location, 'host', $event)"
              label="Host"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Site sharing">{{ location.site_sharing|formatBool|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Status">{{ site.status|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              :site="site"
              label="Type"
              :editable="true"
              edit-type="codelist"
              codelist="property_type"
              edit-field="site.PropertyType"
              :edit-value="site.type"
              @updated="(nv)=>site.type=nv"
            >{{ site.type|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <site-group
              :readonly="isReadOnly()"
              :value="getValue(location, 'site_group')"
              @input="setValue(location, 'site_group', $event)"
              label="Site Group"
            ></site-group>
          </v-col>
          <v-col cols="3">
            <site-investment-type
              :readonly="isReadOnly()"
              :value="getValue(location, 'site_investement_type')"
              @input="setValue(location, 'site_investement_type', $event)"
              label="Site Investment Type"
            ></site-investment-type>
          </v-col>
          <v-col cols="3">
            <coverage-type
              :readonly="isReadOnly()"
              :value="getValue(location, 'coverage_type')"
              @input="setValue(location, 'coverage_type', $event)"
              label="Coverage type"
            ></coverage-type>
          </v-col>
          <v-col cols="3">
            <radio-equipment-type
              :readonly="isReadOnly()"
              :value="getValue(location, 'radio_equipment_type')"
              @input="setValue(location, 'radio_equipment_type', $event)"
              label="Radio equipment type"
            ></radio-equipment-type>
          </v-col>
          <v-col cols="3">
            <bilateral-trilateral
              :readonly="isReadOnly()"
              :value="getValue(location, 'bilateral_trilateral')"
              @input="setValue(location, 'bilateral_trilateral', $event)"
              label="Bilateral/Trilateral"
            ></bilateral-trilateral>
          </v-col>
          <v-col cols="3">
            <project
              :readonly="isReadOnly()"
              :value="getValue(location, 'project')"
              @input="setValue(location, 'project', $event)"
              label="Project"
            ></project>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <responsible-person-radio
              :readonly="isReadOnly()"
              :value="getValue(location, 'responsible_person_radio')"
              @input="setValue(location, 'responsible_person_radio', $event)"
              label="Responsible person, Radio"
            ></responsible-person-radio>
          </v-col>
          <v-col cols="3">
            <responsible-person-transmision
              :readonly="isReadOnly()"
              :value="getValue(location, 'responsible_person_transmision')"
              @input="setValue(location, 'responsible_person_transmision', $event)"
              label="Responsible person, Transmision"
            ></responsible-person-transmision>
          </v-col>
          <v-col cols="3">
            <responsible-person-permit
              :readonly="isReadOnly()"
              :value="getValue(location, 'responsible_person_permit')"
              @input="setValue(location, 'responsible_person_permit', $event)"
              label="Responsible person, Permit"
            ></responsible-person-permit>
          </v-col>
          <v-col cols="3">
            <responsible-person-design
              :readonly="isReadOnly()"
              :value="getValue(location, 'responsible_person_design')"
              @input="setValue(location, 'responsible_person_design', $event)"
              label="Responsible person, Design"
            ></responsible-person-design>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Responsible person, Acqusition">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Responsible person, Construction"
              v-if="location.responsible_person_construction"
            >
              {{ location.responsible_person_construction.name|noDataAvailable }}
            </display-field>
            <display-field
              label="Responsible person, Construction"
              v-if="!location.responsible_person_construction"
            >
              {{ null|noDataAvailable }}
            </display-field>
          </v-col>
          <v-col cols="3">
            <s-a-subcontractor
              :readonly="isReadOnly()"
              :value="getValue(location, 'sa_subcontractor')"
              @input="setValue(location, 'sa_subcontractor', $event)"
              label="SA subcontractor"
            ></s-a-subcontractor>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Site Onair Date"
              :value="getValue(location, 'site_onair_date')"
              @input="setValue(location, 'site_onair_date', $event)"
            />
          </v-col>
          <v-col cols="3">
            <date-picker
              :readonly="isReadOnly()"
              label="Site Deactivation Date"
              :value="getValue(location, 'site_deactivation_date')"
              @input="setValue(location, 'site_deactivation_date', $event)"
            />
          </v-col>
        </v-row>
<!--        <v-row>-->
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <text-field-->
<!--              v-model="firstname"-->
<!--              :rules="nameRules"-->
<!--              :counter="10"-->
<!--              label="First name"-->
<!--              required-->
<!--            ></text-field>-->
<!--          </v-col>-->

<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <text-field-->
<!--              v-model="lastname"-->
<!--              :rules="nameRules"-->
<!--              :counter="10"-->
<!--              label="Last name"-->
<!--              required-->
<!--            ></text-field>-->
<!--          </v-col>-->

<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <text-field-->
<!--              v-model="email"-->
<!--              :rules="emailRules"-->
<!--              label="E-mail"-->
<!--              required-->
<!--            ></text-field>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <form-actions
          v-if="!isReadOnly()"
          :loading="loading"
          :saved="saved"
          v-on:saveData="saveData"
        />
      </v-container>
    </v-form>
  </permissions-view>
</template>

<script>
  import SiteLocationService from '@/services/site-location'
  import DisplayField from '@/components/DisplayField'
  import DatePicker from '@/components/DatePicker'
  import FormActions from '@/components/FormActions'
  import TextField from '@/components/TextField'
  import ReactivityMixin from '@/mixins/Reactivity'
  import SiteGroup from '@/components/codelist/SiteGroup'
  import SiteInvestmentType from '@/components/codelist/SiteInvestmentType'
  import CoverageType from '@/components/codelist/CoverageType'
  import RadioEquipmentType from '@/components/codelist/RadioEquipmentType'
  import BilateralTrilateral from '@/components/codelist/BilateralTrilateral'
  import ResponsiblePersonRadio from '@/components/codelist/ResponsiblePersonRadio'
  import ResponsiblePersonTransmision from '@/components/codelist/ResponsiblePersonTransmision'
  import ResponsiblePersonPermit from '@/components/codelist/ResponsiblePersonPermit'
  import ResponsiblePersonDesign from '@/components/codelist/ResponsiblePersonDesign'
  import PermissionsView from '../../../components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'
  import EditReadField from '@/components/EditReadField'
  import Project from '@/components/codelist/Project'
  import SASubcontractor from '@/components/codelist/SASubcontractor'

  export default {
    name: 'Location',
    components: { SASubcontractor, Project, EditReadField, PermissionsView, ResponsiblePersonDesign, ResponsiblePersonPermit, ResponsiblePersonTransmision, ResponsiblePersonRadio, BilateralTrilateral, RadioEquipmentType, CoverageType, SiteInvestmentType, SiteGroup, TextField, FormActions, DatePicker, DisplayField },
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data () {
      return {
        loading: false,
        saved: false,
        firstname: 'demo',
        location: null,
        neki: null,
        section: 'location',
      }
    },
    watch: {
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      updateData () {
        this.fetchData()
      },
      fetchData () {
        const ls = new SiteLocationService(this.site.id)
        ls.getSingle().then((response) => {
          this.location = response.data.data
          if (Array.isArray(this.location)) {
            this.location = {}
          }
        })
      },
      saveData () {
        this.saved = false
        if (this.valid) {
          this.loading = true
          const ls = new SiteLocationService(this.site.id)
          ls.post(this.location).then((response) => {
            this.saved = true
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
